export enum RefererOptionIdsEnum {
  WordOfMouth = 'word_of_mouth',
  OnlineSearch = 'online_search',
  ReviewSite = 'review_site',
  Blog = 'blog',
  SocialMedia = 'social_media',
  Influencer = 'influencer',
  Podcast = 'podcast',
}
